
import { area_list, sport_type } from '@/apis/insidepage.js';
export default {
    data() {
        return {
            searchParams: {
                areaCode: '',
                module: ''
            },
            config: {
                areas: [],
                //provinces: [],
                sportType: []
            },
        }
    },
    mounted() {
        this.onPageConfig();
    },
    methods: {
        async getSportType() {
            try {
                const res = await sport_type() || {};
                if (res.code == 0) {
                    this.config.sportType = res.data.sportTypes;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async getArea() {
            try {
                this.config.areas = this.getItemValue('openArea');
                // const res = await area_list() || {};
                // if (res.code == 0) {
                //     this.config.areas = res.data;
                //     this.config.provinces = this.config.areas.filter(item => item.parentCode == '7100000000000');
                // } else {
                //     if (res.msg)
                //         throw new Error(res.msg);
                // }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageConfig() {
            await this.getArea();
            await this.getSportType();
        },
        toVenues() {
            var url = '/venues';
            var params = [];
            if (this.searchParams.module !== '') {
                params.push(`type=${this.searchParams.module}`);
            }
            if (this.searchParams.areaCode !== '') {
                params.push(`area=${this.searchParams.areaCode}`);
            }
            if (params.length > 0) {
                url += '?' + params.join('&');
            }
            this.$router.push({ path: url })
        },
        getItemValue(key) {
            const items = this.$store.state.systemConfig || [];
            const res = items.filter(item => item.configKey == key);
            if (res.length > 0) {
                try {
                    return JSON.parse(res[0].configVal);
                } catch (error) {
                    return res[0].configVal;
                }
            }
            return '';
        },
    }
}
